import React from "react";
import { StaticField } from "@intech/web-ui";
import { InfoRendEntidade } from "../../../entidades";
import { Td } from "./styles";

interface LinhaProps {
  linha: InfoRendEntidade
}

export interface TdProps {
  align: "left" | "right";
}

export const Linha: React.FC<LinhaProps> = ({
  linha
}) => {

  function ToMoney(Valor: number | undefined) {
    if (Valor === undefined)
      return 0
    return (
      Valor.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    );
  }

  return (
    <tr>
      <Td align={"left"}>{linha.DES_INFO_REND}</Td>
      <Td align={"right"} style={{ width: 150 }}>
        {linha.VAL_LINHA != 0 && (
          <b>
            {linha.COD_LINHA === "608" ? (linha.VAL_LINHA) : ("R$ " + ToMoney(linha.VAL_LINHA))}
          </b>
        )}
      </Td>
    </tr>
  );
}
